<template>
  <div class="elevation-2 rounded-lg d-flex pa-5 mb-7">
    <div class="mr-5">
      <div class="position-relative">
        <Star />
        <span class="white--text inset-all d-flex justify-center align-center text-subtitle-1 font-weight-medium no-select">{{ review.star }}</span>
      </div>
    </div>
    <div>
      <p class="mb-1">
        <span class="mr-4 text-body-1">{{ review.full_name }}</span>
        <span class="text-caption">{{ review.date | shortDate }}</span>
      </p>
      <div class="d-flex flex-wrap mt-3 mb-2" v-if="review.images">
        <img
          class="rounded-lg mr-2 mb-2 mb-lg-0 mr-lg-5"
          :width="$vuetify.breakpoint.smAndUp ? 100 : 60"
          :height="$vuetify.breakpoint.smAndUp ? 100 : 60"
          v-for="img in review.images"
          :src="img.path"
          :key="img.id"
        />
      </div>
      <p class="secondary--text text--lighten-1 text-wrap">
        {{ review.comment }}
      </p>
    </div>
  </div>
</template>

<script>
import Star from '@/assets/icons/star.svg'

export default {
  components: { Star },

  props: {
    review: { type: Object, required: true }
  }
}
</script>
